import React from 'react'

import ProductListCard from '../product-list-card'

const ProductList = ({data, page}) => {
  let productList = [];

  if (data) {
    productList = data.map(({brand, categoryId, id, images, price, oldPrice, title}) => (
      <ProductListCard brand={brand}
                       categoryId={categoryId}
                       page={page}
                       id={id} key={id}
                       sliderData={{images}}
                       countOfViewed="1"
                       price={price}
                       oldPrice={oldPrice}
                       title={title}/>
    ));
  }

  return productList
};

export default ProductList
